import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('adminToken');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children || <Outlet />;
}

export default PrivateRoute;

